module.exports = new __parcel__URL__("mariam.b981932b.jpg").toString();